import { TURNOVERFORECASTSETTINGSLIST_SEARCH, TURNOVERFORECASTSETTINGSLIST_PAGE } from '../actions/turnoverforecastsettingslistactions';

const state = { search: '', page: 0 };

const getters = {
    page: state => state.page,
    search: state => state.search
};

const actions = {
    [TURNOVERFORECASTSETTINGSLIST_SEARCH]: ({ commit }, search) => {
        commit(TURNOVERFORECASTSETTINGSLIST_SEARCH, search);
    },
    [TURNOVERFORECASTSETTINGSLIST_PAGE]: ({ commit }, page) => {
        commit(TURNOVERFORECASTSETTINGSLIST_PAGE, page);
    }
};

const mutations = {
    [TURNOVERFORECASTSETTINGSLIST_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [TURNOVERFORECASTSETTINGSLIST_PAGE]: (state, page) => {
        state.page = page;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};